export const showNotice = (text, noticeType) => ({
  type: 'SHOW_NOTICE',
  text,
  noticeType
});

export const hideNotice = () => ({
  type: 'HIDE_NOTICE'
});
